let i = 0;

// extras
export const UNREF = i++;
export const ASSIGN = i++;
export const EVALUATE = i++;
export const GATHER = i++;
export const QUERY = i++;

// traps
export const APPLY = i++;
export const CONSTRUCT = i++;
export const DEFINE_PROPERTY = i++;
export const DELETE_PROPERTY = i++;
export const GET = i++;
export const GET_OWN_PROPERTY_DESCRIPTOR = i++;
export const GET_PROTOTYPE_OF = i++;
export const HAS = i++;
export const IS_EXTENSIBLE = i++;
export const OWN_KEYS = i++;
export const PREVENT_EXTENSIONS = i++;
export const SET = i++;
export const SET_PROTOTYPE_OF = i++;
